/* eslint-disable id-length */
import { type Ref } from 'vue';

// eslint-disable-next-line max-statements, max-lines-per-function
export const useWidgetFilterStore = defineStore('filter', () => {
    // State
    const eventTypeFilter: Ref<string> = ref('');
    const startDateFilter: Ref<string> = ref('');
    const startTimeFilter: Ref<string> = ref('');
    const guestAmountFilter: Ref<number> = ref(0);

    return {
        eventTypeFilter,
        startDateFilter,
        startTimeFilter,
        guestAmountFilter,
    };
});
